import { useEffect, useState } from "react"
import { getMedidaById, postMedida, patchMedida } from "../../services/MedidasServices"
import { MedidasFormContext } from "./MedidasContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Medidas } from '../../routes/RoutesConstants'

export const MedidasFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getMedidaByIdData(id)
    }, [])

    const getMedidaByIdData = async (id) => {
        let res = await getMedidaById(id)
        
        if (res) setReport(res)
    }

    const postMedidaData = async (body) => {
        const res = await postMedida(body)
        
        if (res) navigate("/Medidas");
    }

    const patchMedidaData = async (id, body) => {
        const res = await patchMedida(id, body)

        if (res) navigate("/Medidas");
    }


    return <MedidasFormContext.Provider value={{
        report,
        postMedidaData,
        patchMedidaData,
    }} >
        {children}
    </MedidasFormContext.Provider>
}